/*###########################################################################
// Forms
//#########################################################################*/

const forms = {
	config: {

	},

	elements: {},

	init() {
		const self = this

	}
}

window.addEventListener('load', function () {
	forms.init()
})
